/*
 * @Author: huangshuo
 */
<template>
  <div class="file-operate">
    <span
      v-for="(operateIcon, index) in operation"
      :key="index"
      :ref="operateIcon.ref"
      :class="operateIcon.ref"
      class="operation-button"
      @click="ClickHandler($event, operateIcon.ref, operateIcon.operateType)"
      @dblclick="dbclick"
      @mouseenter="mouseenterHandler(operateIcon.ref, $event)"
      @mouseleave="mouseleaveHandler"
    >
      <!-- 气泡提示 -->
      <co-tips
        effect="dark"
        :content="$t(operateIcon.name)"
        placement="top"
      >
        <a class="operation-icon">
          <svg :class="[operateIcon.class, 'item-icon']">
            <use
              :xlink:href="operateIcon.svgId"
              :x="operateIcon.x"
              :y="operateIcon.y"
            />
          </svg>
        </a>
      </co-tips>
    </span>
  </div>
</template>
<script>
import coTips from 'components/common/tips/index.vue'

export default {
  name: 'FileItemOperation',
  components: {
    coTips,
  },
  props: {
    currentData: Object, // 当前列对象
    index: Number, // id索引
    isListMode: Boolean, // 列表或大图模式
    operation: Array, // 操作选项
    selectFile: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {
    /**
             *鼠标进入事件
             */
    mouseenterHandler(ref, $event) {},
    /**
             * 操作菜单鼠标移出事件
             */
    mouseleaveHandler(e) {},
    /**
             * 操作按钮点击事件
             */
    ClickHandler(e, name, operateType) {
      // 选中该文件
      if (this.isListMode || this.selectFile.data.length < 2) this.singleSelect()
      // 抛出选中事件(左键，右键都需要选中)
      if (!this.currentData.checked) {
        this.$emit('singleSelectOperation', { index: this.index, data: this.currentData })
      }
      // 点击的button
      if (e.button === 0) {
        if (name && name != 'mode-more') {
          // 抛出按钮点击事件
          this.$emit('operationAction', { name, operateType })
        } else if (name === 'mode-more') {
          // 如果是大图模式,目前大图模式复用右键菜单
          if (this.isListMode !== undefined && !this.isListMode) {
            // 设置显示位置，并显示菜单
            const pardom = this.$refs['mode-more'][0]
            this.$emit('setPosition', {
              left: e.pageX, top: e.pageY, isShow: true, otherobj: { flag: 'picMode', pardom },
            })
          }
        }
      }
    },
    /**
             * 双击事件
             */
    dbclick(event) {
      this.stopPropagation(event)
    },
    /**
             * 选中操作
             */
    singleSelect() {
      const { index } = this
      const { currentData } = this
      this.$emit('singleSelectOperation', { index, data: currentData })
    },
    /**
             * 阻止冒泡的方法和自身默认事件
             */
    stopPropagation(e) {
      event.preventDefault()
      const evt = e || window.event
      if (evt.stopPropagation) {
        evt.stopPropagation()
      } else {
        evt.cancelBubble = true
      }
    },
  },
}
</script>
<style lang="less" scoped>
/**设置svg的居中问题 */
.icon-i-download, .icon-i-savetobox, .icon-i-preview {
  height: 28px;
  width: 28px;
  position: relative;
  left: -1px;
  top:-1px;
}

// .icon-i-preview{
//     height: 20px;
//     width: 20px;
//     position: relative;
//     top:-1px;
// }

/**更多...hover的位置 */
.icon-i-operation-more {
  width: 16px;
  height: 16px;
  position: relative;
  top: -2px;
  right: -4px;
}

/**鼠标hover的样式 */
.mode-more {
  height: 15px;
  width: 24px;
  display: block;
  border-radius: 2px;
  position: relative;
  top: -1px;
}
.mode-more:hover{
  background-color: #f6f7fa!important;
}

.operation-button {
  cursor: pointer;
}

//禁止点击svg兼容ie
.item-icon{
  pointer-events: none
}

/**
     * 设置模式切换的样式,兼容ie
     */
.operation-icon{
  height:28px;
  width:28px;
  display: block;
}

</style>
